import {
  ArgumentError,
  InvalidInputError,
  UnknownApiError,
} from './errors';

export default function (api) {
  /**
   * @typedef {Object} Channel
   * @property {number} id
   * @property {number} listOrder
   * @property {string} name
   * @property {string[]} tags
   */

  /**
   * @typedef {Object} Product
   * @property {string} id
   * @property {string} name
   * @property {string} tagline
   * @property {string} description
   * @property {string} image
   * @property {number} price
   * @property {Channel[]} channels
   * @property {string[]} channelIds
   * @property {string} requiredPack
   * @property {number} personalisationIncentive
   * @property {string} replaceProduct
   */

  /**
   *
   * @typedef {Object} MarketResponse
   * @property {string} countryCode
   * @property {string} currency
   * @property {Product[]} products
   * @property {Array.<Object>} additionalData
   */

  /**
   * @memberof API
   * @instance
   */
  const market = {
    /**
     * Retrieve a market. The response contains the products available for that market.
     *
     * @method
     * @this API
     *
     * @param {Object} payload
     * @param {string} payload.marketId Usually a two char country code such as 'de'
     *
     * @return {Promise} promise
     * @fulfill {MarketResponse}
     * @reject {ArgumentError} Market ID is required
     * @reject {InvalidInputError} Market cannot be found
     * @reject {UnknownApiError} Server returned with unexpected status code
    */
    get: function get(payload = {}) {
      if (typeof payload.marketId === 'undefined' || typeof payload.marketId !== 'string') {
        return Promise.reject(new ArgumentError('payload.marketId is required and must be a string'));
      }

      return this.request('get', `/market/v2/market/${payload.marketId}`)
        .then((res) => {
          switch (res.status) {
            case 200: {
              return res.body;
            }
            case 404: {
              throw new InvalidInputError('Market not found', res);
            }
            default: {
              throw new UnknownApiError('server returned with unhandled status code', res);
            }
          }
        });
    }.bind(api),
  };

  return market;
}
